export default {
  body: `
    What would happen if you got infected with coronavirus?
  `,
  topic: `
    What would happen if I got infected with coronavirus.
  `,
};
